import { render, staticRenderFns } from "./BaseButtonDownload.vue?vue&type=template&id=02c22936&scoped=true&"
import script from "./BaseButtonDownload.vue?vue&type=script&lang=js&"
export * from "./BaseButtonDownload.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonDownload.vue?vue&type=style&index=0&id=02c22936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c22936",
  null
  
)

export default component.exports